/**
 * @ngdoc component
 * @name common.component.account:ItxResetPassword
 * @requires $rootScope
 * @requires common.wishlist.service:ItxWishlistSvc
 * @requires ItxScreenSizeSvc
 * @requires common.service:ItxLoginSvc
 * @description
 * Reset password component
 * Shows a modal to reset the password with the user's email or SMS.
 * @param {string} email - User email
 */
(function () {

    'use strict';

    var ItxResetPasswordCmp = {
        bindings: {
            email: '=userLogin',
            // Binding para el atributo de comprobación de si el popup proviene de un enlace expirado
            expired: '<'
        },
        require: {
            'userAccessCtrl': '^itxUserAccess'
        },
        controller: ItxResetPasswordCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'ItxResetPasswordCmp.html'
    };

    ItxResetPasswordCmpCtrl.$inject = [
        '$scope',
        'ngDialog',
        'ItxErrorMessagesFct',
        'ItxShareDataFct',
        'imAccessService',
        'ItxTranslateSvc',
        'NostromoSvc',
        'ItxPhoneSvc',
        '$timeout'
    ];

    function ItxResetPasswordCmpCtrl(
        $scope,
        ngDialog,
        ItxErrorMessagesFct,
        ItxShareDataFct,
        imAccessService,
        ItxTranslateSvc,
        NostromoSvc,
        ItxPhoneSvc,
        $timeout
    ) {

        var _this = this;


        _this.countryCode = inditex.iStoreJSON.countryCode;
        _this.visibleCodeInput = false;
        _this.validationModel = {
            phone: '',
            code: ''
        };
        _this.SMSClicked = false;


        _this.visibleCodeInput = false;
        _this.serviceDown = false;
        _this.limitExceded = false;

        _this.password = "";

        _this.passwordValid = false;
        _this.hasOneNumber = true;
        _this.isLengthMin = true;
        _this.isLowerOneCharacter = true;
        _this.isUpperOneCharacter = true;
        _this.isRepeatCharacter = true;

        _this.phoneLogin = {
            enabled: false,
            loaded: false
        }


        _this.$onInit = function () {

            inditex.getXconfiguracionValue('PHONE_REGISTER_LOGIN_ENABLED', function (status, value) {
                _this.phoneLogin.loaded = true;
                if (value == 1) {
                    _this.phoneLogin.enabled = true;
                }
                $timeout();
            });

            // Define el título y el texto del popup
            _this.popupTitle = ItxTranslateSvc.translateCms('legacy.ItxResetPasswordPage.enterEmail');
            _this.popupBody = ItxTranslateSvc.translateCms('legacy.ItxResetPasswordPage.instrucciones');

            _this.SMSButtonText = inditex.text('ItxPhoneValidation.phone_verify');

            inditex.getXconfiguracionValue('ENABLED_SMS_PASSWORD_RESET', function (status, value) {
                if (value === '1') {
                    _this.isSmsPasswordResetEnabled = true;
                }
            });

            if (ItxShareDataFct.get('recover-password')) {
                _this.email = ItxShareDataFct.get('recover-password');
                ItxShareDataFct.remove('recover-password');
            }

            _this.recoverMode = null;
            _this.showCaptcha = false;
            _this.showEmailMessage = false;
            _this.errorMessage = ItxTranslateSvc.translateCms('legacy.ItxUserPasswordForget.warning.userNotFound');
            // _this.isSmsPasswordResetEnabled = false;
            _this.captchaId = null;
            _this.itxErrorMessagesFct = ItxErrorMessagesFct;

            // En caso de que el atributo del binding "expire" sea true
            if (_this.expired) {
                // Modifica el título y el texto del popup
                _this.popupTitle = ItxTranslateSvc.translateCms('legacy.ItxResetPasswordPage.enterEmailAgain');
                _this.popupBody = ItxTranslateSvc.translateCms('legacy.ItxResetPasswordPage.expiredLinkInstructions');
            }

        };
        _this.$onChanges = function () {
            if (
                _this.userAccessCtrl.isActive('recover-password')) {
                NostromoSvc.recoverPasswd();
            }
        }

        _this.onUpdateEmail = function () { };

        _this.recoverPassword = function (recoverMode) {

            _this.recoverMode = recoverMode;
            _this.recoverForm.$setSubmitted();

            if (_this.recoverForm.$valid) {
                let userData = _this.email;

                if (_this.phoneLogin.loaded && _this.phoneLogin.enabled) {
                    userData = _this.validationModel.phone;
                }

                $('body').on('touchstart touchend', '.no-hover', function () {
                    $(this).toggleClass('no-hover');
                });


                if (recoverMode === 'SMS') {
                    if (_this.phoneLogin.loaded && _this.phoneLogin.enabled) {
                        console.log('returnRequestLoginPhone')
                        returnRequestLoginPhone(userData)
                    } else {
                        console.log('returnRequest')
                        returnRequest(userData, recoverMode);
                    }
                } else {
                    console.log('returnRequest else')
                    returnRequest(userData, recoverMode);
                }
            }
            else {
                // IManalytics errores formulario recuperar_contrasena
                imAccessService.createForm('recuperar_contrasena', _this.recoverForm);
            }
            function returnRequest(email, recoverMode) {
                var captchaObj = {
                    'captchaId': _this.captchaId,
                    'captchaValue': _this.captchaResponse
                };
                joyr.rest.xRestResetPassword(email, recoverMode, captchaObj)
                    .done(function (response) {

                        _this.userEMailRecover = _this.email;
                        if (recoverMode === 'EMAIL') {
                            _this.showEmailMessage = true;
                        } else {
                            _this.smsMessage = ItxTranslateSvc.translateCms('legacy.ItxResetPasswordPage.smsInstructions');
                            _this.userAccessCtrl.show('recover-password-sms');
                        }
                        imAccessService.recoveryPasswordOK();
                    })
                    .Catch(function (error) {
                        if (error.code === 3 &&
                            error.errorKey === '_WARN_CAPTCHA_VALIDATION_FAILED') {
                            _this.showCaptcha = true;
                        } else {
                            _this.showCaptcha = false;
                        }
                        $scope.$broadcast('captcha:reloadImage');
                        ItxErrorMessagesFct.add(error.errorMessage, 'userAccessCtrl', 'ERROR');
                        _this.errorMessage = error.errorMessage;
                        imAccessService.createServer('recuperar_contrasena', _this.recoverForm, error);
                    })
                    .Finally(function () {
                        $scope.$apply();
                    });
            }

            function returnRequestLoginPhone(phone) {

                joyr.rest.xRestResetPasswordPhone(phone)
                    .done(function (response) {
                        _this.smsMessage = ItxTranslateSvc.translateCms('legacy.ItxResetPasswordPage.smsInstructions', response.subscriberNumber.slice(-4));
                        _this.userAccessCtrl.show('recover-password-sms');
                        imAccessService.recoveryPasswordOK();
                    })
                    .Catch(function (error) {
                        if (error.code === 3 &&
                            error.errorKey === '_WARN_CAPTCHA_VALIDATION_FAILED') {
                            _this.showCaptcha = true;
                        } else {
                            _this.showCaptcha = false;
                        }
                        $scope.$broadcast('captcha:reloadImage');
                        ItxErrorMessagesFct.add(error.errorMessage, 'userAccessCtrl', 'ERROR');
                        _this.errorMessage = error.errorMessage;
                        imAccessService.createServer('recuperar_contrasena', _this.recoverForm, error);
                    })
                    .Finally(function () {
                        $scope.$apply();
                    });
            }
        };

        _this.showChangePassword = function () {
            _this.recoverSMSForm.$setSubmitted();
            if (_this.recoverSMSForm.$valid) {

                _this.userAccessCtrl.setActivationCode(_this.code);
                joyr.rest.xRestValidateSMSCode(_this.code, _this.email, 1)
                    .done(function () {
                        _this.userAccessCtrl.show('change-password');
                        imAccessService.createEvent('recuperar_contrasena', 'validar_codigo_sms_ok');
                    })
                    .Catch(function (error) {
                        ItxErrorMessagesFct.add(error.errorMessage, 'userAccessCtrl', 'ERROR');
                        imAccessService.createServer('recuperar_contrasena', _this.recoverSMSForm, error);

                    })
                    .Finally(function () {
                        $scope.$apply();
                    });
            }
            else {
                imAccessService.createForm('recuperar_contrasena', _this.recoverSMSForm);
            }
        };

        _this.openContactForm = function () {
            ngDialog.open({
                template: '<itx-contact close="closeThisDialog()"></itx-contact>',
                plain: true,
                className: 'contact-dialog ngdialog-theme-plain new-modal ma-modal-lg',
                showClose: true
            });
            return false;
        };

        _this.back = function () {
            _this.userAccessCtrl.closeDialog();
        };


        _this.sendSMS = function () {
            _this.SMSButtonText = 'SENDING CODE...';
            ItxPhoneSvc.sendSMS("", _this.validationModel.phone).then(function () {
                _this.visibleCodeInput = true;
                _this.SMSClicked = true;
                _this.SMSButtonText = ItxTranslateSvc.translateCms('legacy.ItxPhoneValidation.phone_verify_resend');
                setTimeout(function () {
                    _this.SMSClicked = false;
                    $scope.$digest();
                }, 60000);
            }, function (error) {
                if (error.errorKey && error.errorKey.indexOf('_ERR_SMS_SERVICE_DOWN') > -1) {
                    _this.serviceDown = true;
                }
                else if (error.errorKey && error.errorKey.indexOf('_ERR_SMS_MAX_RETRIES') > -1) {
                    _this.limitExceded = true;
                }
            });
        };

        _this.validatePassword = function () {

            if (_this.password === undefined) {
                _this.password = '';
            }

            let hasNumber = /\d/.test(_this.password);
            _this.hasOneNumber = !hasNumber;


            let length = /.{8,}/.test(_this.password);
            _this.isLengthMin = !length;

            let patternLowerOneCharacter = new RegExp('.*[a-z]');
            let isLoChar = patternLowerOneCharacter.test(_this.password);
            _this.isLowerOneCharacter = !isLoChar;

            let patternUpperOneCharacter = new RegExp('.*[A-Z]');
            let isUpChar = patternUpperOneCharacter.test(_this.password);
            _this.isUpperOneCharacter = !isUpChar;

            _this.isRepeatCharacter = !_this.isRepeatChar();

            let passWordValid = _this.isRepeatChar() &&
                !_this.hasOneNumber &&
                !_this.isLengthMin &&
                !_this.isLowerOneCharacter &&
                !_this.isUpperOneCharacter;

            _this.passwordValid = passWordValid;

        };



        _this.isRepeatChar = function () {
            if (_this.password === '') {
                return false;
            } else {
                let d = _this.password;
                return /^(?!.*(.)\1{3})^.*$/.test(d);
            }
        };

        _this.changePasswordMobile = function () {
            _this.recoverSMSForm.$setSubmitted();
            _this.resetErrorMessages();

            if (_this.recoverSMSForm.$valid) {
                let captchaObj = {
                    'captchaId': _this.captchaId,
                    'captchaValue': _this.captcha
                };

                joyr.rest.xRestUpdateResetUserPasswordPhone(_this.validationModel.phone, _this.code,
                     _this.password, captchaObj)
                    .done(function () {
                        NostromoSvc.recoverPasswdDone();
                        _this.userAccessCtrl.show('change-password-success');
                        let options = {
                            phoneLoginEnabled : true
                        }
                        
                        if(_this.validationModel.phone) {
                            ItxLoginSvc.login(_this.validationModel.phone, _this.password, options);
                        }
                        imAccessService.createEvent('recuperar_contrasena','modificar_contrasena_ok');
                    })
                    .Catch(function (error) {
                        ItxErrorMessagesFct.add(error.errorMessage, 'userAccessCtrl', 'ERROR');
                        imAccessService.createServer('recuperar_contrasena',  _this.changeForm, error);
                    })
                    .Finally(function () {
                        $scope.$broadcast('captcha:reloadImage');
                        $scope.$apply();
                    });

            }
            else {
                /**
                 * IManalytics errores formulario recuperar_contrasena
                 */
                imAccessService.createForm('recuperar_contrasena', _this.changeForm);
            }
        };

        _this.resetErrorMessages = function () {
            if (ItxErrorMessagesFct.any('userAccessCtrl', 'ERROR')) {
                ItxErrorMessagesFct.reset('userAccessCtrl', 'ERROR');
            }
        };

    }

    angular.module('itxApp.common')
        .component('itxResetPassword', ItxResetPasswordCmp);

})(window.itxApp);
